// extracted by mini-css-extract-plugin
export var equalColumn = "_is-0";